import React, { createContext, useContext, useState, useCallback } from 'react';
import QuickViewModal from '../components/product/QuickViewModal';

const QuickViewContext = createContext();

export const QuickViewProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [productId, setProductId] = useState(null);
  const [productSlug, setProductSlug] = useState(null);

  const openQuickView = useCallback((id, slug) => {
    setProductId(id);
    setProductSlug(slug);
    setIsOpen(true);
  }, []);

  const closeQuickView = useCallback(() => {
    setIsOpen(false);
    // Clear after animation
    setTimeout(() => {
      setProductId(null);
      setProductSlug(null);
    }, 300);
  }, []);

  return (
    <QuickViewContext.Provider
      value={{ openQuickView, closeQuickView, isOpen }}
    >
      {children}
      <QuickViewModal
        open={isOpen}
        onClose={closeQuickView}
        productId={productId}
        productSlug={productSlug}
      />
    </QuickViewContext.Provider>
  );
};

export const useQuickView = () => {
  const context = useContext(QuickViewContext);
  if (!context) {
    throw new Error('useQuickView must be used within QuickViewProvider');
  }
  return context;
};

export default QuickViewContext;
